import {getCollisions} from '@reach/popover'
import {useRect} from '@reach/rect'
import React from 'react'

export type PopoverDirection = 'below' | 'above'

interface PopoverDirectionArgs {
    triggerRef: React.RefObject<HTMLElement>
    popoverRef: React.RefObject<HTMLElement>
}

const usePopoverDirection = ({triggerRef, popoverRef}: PopoverDirectionArgs) => {
    const [direction, setDirection] = React.useState<PopoverDirection>('below')
    const triggerRect = useRect(triggerRef)
    const popoverRect = useRect(popoverRef)

    // Calculate if the popover can fit below the trigger using `getCollisions`,
    // which is what Reach uses internally for edge collision detection.
    const collidesDown = React.useMemo(() => {
        if (triggerRect && popoverRect) {
            return getCollisions(triggerRect, popoverRect).directionUp
        }

        return false
    }, [triggerRect, popoverRect])

    // Update the popover direction
    React.useEffect(() => {
        if (triggerRect && popoverRect) {
            if (collidesDown) {
                setDirection('above')
            } else {
                setDirection('below')
            }
        }
    }, [triggerRect, popoverRect, collidesDown])

    return direction
}

export default usePopoverDirection
